import { AddNewWebsiteIndexEntryParams } from '../types';

// Same region the backend falls back to, so a website added without setup data still gets loading speed monitoring.
export const DEFAULT_MONITORING_REGIONS = ['us-east-1'];

type DomainSetupData = {
    homepageUrl: string | null;
    competitors: string[] | null;
    monitoringRegions: string[] | null;
    searchEngineMarket: { sem_language_code: string; sem_location: string } | null;
};

export const EMPTY_DOMAIN_SETUP_DATA: DomainSetupData = {
    homepageUrl: null,
    competitors: null,
    monitoringRegions: null,
    searchEngineMarket: null,
};

export default function buildWebsiteIndexEntryParams(domain: string, setupData: DomainSetupData): AddNewWebsiteIndexEntryParams {
    const { homepageUrl, competitors, monitoringRegions, searchEngineMarket } = setupData;

    return {
        domain: domain,
        homepage: homepageUrl || `https://${domain}`,
        settings: {
            competitors: competitors || [],
            regions: monitoringRegions || DEFAULT_MONITORING_REGIONS,
            notifications: ["ping_uptime", "http_uptime", "page_load_timeout"],
            language_code: searchEngineMarket?.sem_language_code || "en",
            location_name: searchEngineMarket?.sem_location || "United States",
        }
    };
}
